import { Flex, Image, Text } from "@chakra-ui/react"

import React from "react"

interface Props {
  logo: string
  label: string
  isSelected?: boolean
  onClick: () => void
}

const CloudProviderSelectionButton: React.FC<Props> = ({
  logo,
  label,
  onClick,
  isSelected = false,
}) => {
  return (
    <Flex
      flexDirection="column"
      position="relative"
      p={4}
      gap={3}
      borderWidth={1}
      borderColor={isSelected ? "blackAlpha.200" : "transparent"}
      backgroundColor={isSelected ? "blackAlpha.50" : "transparent"}
      borderRadius="xl"
      cursor="pointer"
      alignItems="center"
    >
      <Image src={logo} alt={label} boxSize="36px" />
      <Text fontWeight="bold">{label}</Text>
      <Flex
        position="absolute"
        className="cloud-provider-selection-button-overlay"
        top={0}
        right={0}
        left={0}
        bottom={0}
        backgroundColor={isSelected ? "transparent" : "whiteAlpha.600"}
        _hover={{ backgroundColor: "transparent" }}
        onClick={onClick}
      />
    </Flex>
  )
}

export default CloudProviderSelectionButton
